<template>
	<div class="accordion-item" :class="{ 'is-open': isOpen, 'is-height-auto': isHeightAuto }">
		<!-- Header -->
		<div class="accordion-header" @click="toggle()">
			<div class="heading-xs">{{ title }}</div>
			<div class="icon"><IconChevronDown /></div>
		</div>

		<!-- Body -->
		<div ref="accordionBodyRef" class="accordion-body" :style="{ maxHeight: isOpen ? accordionBodyHeight + 'px' : '0px' }">
			<div class="content text-md">
				<slot />
			</div>
		</div>
	</div>
</template>

<script setup>
import { inject, onMounted } from 'vue';
import { IconChevronDown, IconArrowLeft, IconLeaf } from '@tabler/icons-vue';
import { nextTick, ref } from 'vue';
import { router } from '@inertiajs/vue3';

const props = defineProps({
	title: {
		type: String,
		required: false,
	},

	count: {
		type: [String, Number],
		required: false,
	},

	icon: {
		type: String,
		required: false,
	},

	to: {
		type: String,
		required: false,
	},
});

const type = inject('accordionType', 'default');
const startOpen = inject('accordionStartOpen', true);

const isOpen = ref(false);
const isHeightAuto = ref(false);
const accordionBodyRef = ref(null);
const accordionBodyHeight = ref(0);

onMounted(() => {
	isOpen.value = startOpen;

	if (isOpen.value) {
		isHeightAuto.value = true;
		setBodyHeight();
	}
});

function setBodyHeight() {
	accordionBodyHeight.value = isOpen.value ? accordionBodyRef.value.scrollHeight : 0;
}

function toggle() {
	isOpen.value = !isOpen.value;
	isHeightAuto.value = false;

	nextTick(() => setBodyHeight());
}
</script>
